import { createFileRoute, redirect } from '@tanstack/react-router'
import {
  VISIO_REVIEWS_PAGE_READ,
  VISIO_REVIEWS_SCREENS,
} from '~/components/routes/visioReviews/tabs'
import { withRoutePermissions } from '~/utils/rbac'
import { firstAuthorizedScreen } from '~/utils/rbacModuleIndex'

/**
 * L'écran n'a pas de contenu propre : chaque onglet est une route. On redirige vers le premier
 * écran accessible — l'administration comprise, qui n'est pas un onglet mais reste le seul écran
 * ouvrable d'un rôle qui n'a que `read visio.administration.administration` (BLOQ-02).
 * `withRoutePermissions` refuse d'abord l'accès si aucun ne l'est.
 */
export const Route = createFileRoute('/_authenticated/visio-reviews/')({
  staticData: {
    permission: VISIO_REVIEWS_PAGE_READ,
  },
  beforeLoad: ({ context }) => {
    const first = firstAuthorizedScreen(context.ability, VISIO_REVIEWS_SCREENS)
    throw redirect({ to: first?.to ?? VISIO_REVIEWS_SCREENS[0].to })
  },
})
withRoutePermissions(Route)
